import React from 'react';

import Card from 'react-bootstrap/Card';

import ListGroup from 'react-bootstrap/ListGroup';

import {toListGroupCompact} from './Trainer.js';


/*
Renders a detailed view of a Trainer
 */
let TrainerDetails = ({
	trainer,

	// admin rights
	isAdmin
}) => {
	// render

	return (
		<Card>
			<Card.Header>{'Trainer-Daten'}</Card.Header>
			<ListGroup variant = 'flush'>
				{toListGroupCompact(trainer, isAdmin)}
			</ListGroup>
		</Card>
	);
};

export default TrainerDetails;
